import React from 'react';
import {AccentedSvgIcon, AccentedSvgIconProps} from './AccentedSvgIcon';

export const QuoteIcon = (props: AccentedSvgIconProps): JSX.Element => (
    <AccentedSvgIcon {...props} className="ue-icon-quote">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0,9.88v9.88H9.88V9.88H4.24A5.63,5.63,0,0,1,9.88,4.24V0A9.88,9.88,0,0,0,0,9.88ZM24,4.24V0a9.88,9.88,0,0,0-9.88,9.88v9.88H24V9.88H18.35A5.64,5.64,0,0,1,24,4.24Z"
        />
    </AccentedSvgIcon>
);
